// Messages posted by the sf-runtime the animations are built with.
interface AnimationMessage {
  source?: string
  type?: string
  height?: number
}

up.compiler('[data-animation-toggle]', (element: HTMLElement) => {
  const textContent = element.querySelector<HTMLElement>('[data-animation-toggle--content="text"]')!
  const animationContent = element.querySelector<HTMLElement>(
    '[data-animation-toggle--content="animation"]',
  )!
  let iframe: HTMLIFrameElement | undefined

  up.on(
    element,
    'click',
    '[data-animation-toggle--switch]',
    (_event: Event, button: HTMLElement) => {
      switchTo(button.getAttribute('data-animation-toggle--switch')!)
    },
  )

  function switchTo(target: string): void {
    textContent.hidden = target !== 'text'
    animationContent.hidden = target !== 'animation'
    element.querySelectorAll('[data-animation-toggle--switch]').forEach((button) => {
      button.classList.toggle(
        '-active',
        button.getAttribute('data-animation-toggle--switch') === target,
      )
    })

    if (target === 'animation') iframe ??= buildIframe()
  }

  function buildIframe(): HTMLIFrameElement {
    const newIframe = document.createElement('iframe')
    newIframe.className = 'video-animation--iframe'
    newIframe.title = 'Animation'
    // Without allow-same-origin the animation runs in an opaque origin, away from the user's session.
    newIframe.setAttribute('sandbox', 'allow-scripts')
    // The reported height leaves out overflowing shadows, which would otherwise add a scrollbar.
    newIframe.setAttribute('scrolling', 'no')
    newIframe.src = animationContent.getAttribute('data-animation-toggle--src')!
    animationContent.append(newIframe)
    return newIframe
  }

  function onMessage(event: MessageEvent<AnimationMessage | null>): void {
    if (!iframe || event.source !== iframe.contentWindow) return

    const { source, type, height } = event.data ?? {}
    if (source === 'sf-interactive' && type === 'resize' && typeof height === 'number') {
      iframe.style.height = `${height}px`
    }
  }

  window.addEventListener('message', onMessage)
  return () => window.removeEventListener('message', onMessage)
})
